import { MenuItem, TextField } from '@mui/material';

export function BookSearchDropDownField({ selectOptions, type, handleDropDown, searchKey, sx }) {
  
  const handleType = e => {
    handleDropDown(e.target.value);
  };
  return (
    <>
    <TextField
      value={searchKey}
      type={type ? type : 'text'}
      placeholder={"Select option"}
      variant='outlined'
      onChange={handleType}
      select
      sx={sx && sx}
    >
      {selectOptions &&
        selectOptions.map((option, index) => (
          <MenuItem key={1 + index} value={option.value}>
            {option.text}
          </MenuItem>
        ))}
    </TextField>
  </>
  );
}
